module.exports = __webpack_public_path__ + "img/benovelty-apis.3b7ac610.svg";